import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LABELS, SEGMENT_ROUTES, DETAIL_LABELS } from '../../config/routeLabels';

/**
 * 🍞 Fil d'Ariane : indique où l'on se trouve et permet de remonter d'un niveau.
 */

const Breadcrumbs = ({ className = '' }) => {
  const location = useLocation();
  const segments = location.pathname.split('/').filter(Boolean);
  if (segments.length === 0) return null;

  return (
    <nav aria-label="Fil d'Ariane" className={className}>
      <ol className="mx-auto flex max-w-6xl flex-wrap items-center gap-2 text-sm text-gray-600">
        <li><Link to="/" className="text-blue-700 hover:text-blue-900 hover:underline">Accueil</Link></li>
        {segments.map((segment, index) => {
          const parent = segments[index - 1];
          const label = LABELS[segment] || (parent && DETAIL_LABELS[parent]) || decodeURIComponent(segment);
          const to = SEGMENT_ROUTES[segment] || `/${segments.slice(0, index + 1).join('/')}`;
          const isLast = index === segments.length - 1;
          return (
            <li key={`${segment}-${index}`} className="flex items-center gap-2">
              <span className="text-gray-400" aria-hidden="true">/</span>
              {isLast ? (
                <span className="font-medium text-gray-900" aria-current="page">{label}</span>
              ) : (
                <Link to={to} className="text-blue-700 hover:text-blue-900 hover:underline">{label}</Link>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
